import api, { clearAuth } from "./api";

/**
 * 🔐 Login user and store tokens + profile.
 */
export const login = async (username, password) => {
  try {
    // ✅ Use correct JWT endpoint (SimpleJWT default)
    const resp = await api.post("users/token/", { username, password });
    const { access, refresh } = resp.data;

    // ✅ Save tokens locally
    localStorage.setItem("accessToken", access);
    localStorage.setItem("refreshToken", refresh);

    // ✅ Fetch user profile after successful login
    const user = await getProfile();
    localStorage.setItem("user", JSON.stringify(user));

    return { user, tokens: { access, refresh } };
  } catch (err) {
    console.error("❌ Login failed:", err.response?.data || err.message);
    throw err;
  }
};

/**
 * 👤 Fetch logged-in user's profile.
 */
export const getProfile = async () => {
  try {
    const resp = await api.get("users/profile/");
    return resp.data;
  } catch (err) {
    console.error("❌ Failed to fetch profile:", err.response?.data || err.message);
    throw err;
  }
};

/**
 * 🚪 Logout helper — clears all stored auth info.
 */
export const logout = () => {
  clearAuth();
};
